export const AUDIO_CONSTRAINTS = {
  echoCancellation: false,
  autoGainControl: false,
  noiseSuppression: false,
};

const PREFERRED_MIME_TYPES = [
  'audio/webm;codecs=opus',
  'audio/ogg;codecs=opus',
  'audio/webm',
];

const AUDIO_BITS_PER_SECOND = 128000;

export function getMediaRecorderOptions() {
  const mimeType = PREFERRED_MIME_TYPES.find(
    (type) => window.MediaRecorder?.isTypeSupported?.(type)
  );

  return {
    ...(mimeType && { mimeType }),
    audioBitsPerSecond: AUDIO_BITS_PER_SECOND,
  };
}
